module.exports = __webpack_public_path__ + "static/billsbot-usa-5844504ab4b0da2fea0209ea79d2eb64.svg";